import { PanelBottom, PanelRight } from "lucide-react";
import { cn } from "@wa/ui";
import { useT } from "../../../i18n/I18nProvider";
import { IconBtn } from "../../ui";
import type { ReadingPane } from "./readingPane";

/**
 * The switch between the reading pane beside the list and the reading pane
 * under it.
 *
 * It sits in the list pane's head next to the density toggle, because the two
 * answer the same kind of question - how do I want this screen shaped - and an
 * operator looking for one will find the other. Both list panes on the mail
 * screen carry it (the CRM's own threads and the mail server's folders), so the
 * shape does not silently become unchangeable the moment an IMAP folder is
 * opened.
 *
 * A pressed toggle rather than a menu, for the reason the density toggle gives:
 * there are exactly two states and the change is visible the instant it
 * happens. The icon shows where the pane is now; the hint under the cursor says
 * where clicking would put it.
 */
export function ReadingPaneToggle({ pane, onPane }: { pane: ReadingPane; onPane: (next: ReadingPane) => void }) {
  const t = useT();
  const bottom = pane === "bottom";

  return (
    <IconBtn
      className={cn(bottom && "is-on")}
      onClick={() => onPane(bottom ? "right" : "bottom")}
      aria-pressed={bottom}
      aria-label={t("mail.readingPane.label")}
      title={bottom ? t("mail.readingPane.toRight") : t("mail.readingPane.toBottom")}
    >
      {bottom ? <PanelBottom className="size-4" /> : <PanelRight className="size-4" />}
    </IconBtn>
  );
}
